// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gallade_mega: PokeData = {
  "id": 10068,
  "name": "gallade-mega",
  "height": 16,
  "weight": 564,
  "base_experience": 278,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "leer",
    "confusion",
    "teleport",
    "double-team",
    "slash",
    "protect",
    "false-swipe",
    "fury-cutter",
    "helping-hand",
    "aerial-ace",
    "leaf-blade",
    "feint",
    "close-combat",
    "night-slash",
    "psycho-cut",
    "wide-guard",
    "stored-power",
    "quick-guard",
    "heal-pulse"
  ],
  "moves": [
    "leer",
    "protect",
    "aerial-ace",
    "close-combat",
    "night-slash",
    "prismatic-cage",
    "psychic-terrain",
    "calm-mind",
    "psychic",
    "drain-punch",
    "double-kick",
    "vacuum-wave",
    "kinesis"
  ],
  "evolution_chain": {
    "id": 140,
    "item": null,
    "species": [
      {
        "name": "ralts",
        "order": 305,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kirlia",
        "order": 306,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 280,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gardevoir",
        "order": 307,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gallade",
        "order": 308,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "male"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 122,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
